import React, { PureComponent, RefObject, createRef } from 'react';

import { RedditMetadata } from 'api';

interface IProps {
  url: RedditMetadata['url'];
}

class EmbedReddit extends PureComponent<IProps> {
  container: RefObject<HTMLDivElement>;
  observer: MutationObserver;

  constructor(props: IProps) {
    super(props);
    this.container = createRef();
  }

  componentDidMount() {
    this.loadPost();
  }

  loadPost() {
    const { url } = this.props;
    const { current } = this.container;

    const html = `<blockquote class="reddit-card"><a href=${url} /></blockquote>`;
    const template = document.createElement('template');
    template.innerHTML = html;

    current.appendChild(template.content.firstChild);
  }

  render() {
    return <div ref={this.container} />;
  }
}

export default EmbedReddit;
